/** @jsx jsx */
import { jsx, css } from '@emotion/core' // eslint-disable-line
import React, { Component } from 'react' // eslint-disable-line
import { observer } from 'mobx-react'
import * as dayjs from 'dayjs'
import { Table, Divider, Icon } from 'antd'
import { accountingAction } from '../../action/accounting'
import { GeneralStyles } from '../../styles/general'

import BusinessStatus from '../../business/status'
import StatusTag from '../../components/StatusTag'

import InstanceViewer from '../../components/business/InstanceViewer'
import MachineViewer from '../../components/business/MachineViewer'
import UserViewer from '../../components/business/UserViewer'

interface IOrderListProps {}

interface IOrderListState {
  pageList: any[]

  loading: boolean

  pagination: {
    current: number
    total: number
    size: number
  }
}

interface OrderList {
  props: IOrderListProps
  state: IOrderListState
}

const pageColumns = [
  {
    title: '序号',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '实例Id',
    dataIndex: 'instance_id',
    key: 'instance_id',
    render: (text: any) => <InstanceViewer instance_id={text}/>,
  },
  {
    title: '机器Id',
    dataIndex: 'machine_id',
    key: 'machine_id',
    render: (text: any) => <MachineViewer machine_id={text}/>,
  },
  {
    title: '用户',
    dataIndex: 'uid',
    key: 'uid',
    render: (text: any) => <UserViewer uid={text}/>,
  },
  {
    title: '总时长',
    dataIndex: 'hour',
    key: 'hour',
  },
  {
    title: 'GPU',
    dataIndex: 'unit',
    key: 'unit',
  },
  {
    title: '创建时间',
    dataIndex: 'create_time',
    key: 'create_time',
    render: (text: any) => (
      <span>{dayjs(text).format('YYYY年MM月DD日 HH:mm:ss')}</span>
    ),
  },
  {
    title: '状态',
    key: 'status',
    dataIndex: 'status',
    render: (status: any, item: any) => {
      return (
        <span>
          <StatusTag item={item} status={status} config={BusinessStatus.order}/>
        </span>
      )
    },
  },
  {
    title: '操作',
    key: 'action',
    render: (text: any, record: any) => (
      <span>
        <a href="#">查看</a>
        <Divider type="vertical" />
        <a href="#">更多</a>
      </span>
    ),
  },
]

@observer
class OrderList extends Component {
  constructor(props: IOrderListProps) {
    super(props)

    this.state = {
      loading: true,
      pageList: [],
      pagination: {
        current: 1,
        total: 0,
        size: 10,
      },
    }
  }

  fetchOrderList = (condition?: any) => {
    this.setState((prevState: IOrderListState, props: IOrderListProps) => ({
      loading: true,
    }))
    return accountingAction.fetchOrderList(condition).catch(err => {
      this.setState((prevState: IOrderListState, props: IOrderListProps) => ({
        loading: false,
      }))
    })
  }

  componentDidMount() {
    this.fetchOrderList().then((responseData) => {
      this.setState((prevState: IOrderListState, props: IOrderListProps) => ({
        loading: false,
        pageList: responseData.list,
        pagination: {
          ...prevState['pagination'],
          total: responseData.total,
        },
      }))
    })
  }

  handleTableChange = (pagination: any) => {
    if (pagination['current'] === this.state.pagination.current) {
      return
    }

    this
      .fetchOrderList({ pn: pagination['current'] })
      .then((responseData) => {
        this.setState((prevState: IOrderListState, props: IOrderListProps) => ({
          loading: false,
          pageList: responseData.list,
          pagination: {
            ...prevState['pagination'],
            current: pagination['current'],
            total: responseData.total,
          },
        }))
      })
  }

  render() {
    const pageList = this.state.pageList.map((item: any) => {
      return {
        key: item['uid'],
        ...item,
      }
    })

    return (
      <div className="general-page" css={GeneralStyles['general-page']}>
        <div css={GeneralStyles['page-head']}>
          <div className="head-title">
            <span className="title-text"><Icon type="profile" /> 订单列表</span>
          </div>
        </div>
        <div css={GeneralStyles['page-content']}>
          <div css={GeneralStyles['content-pane']}>
            <Table
              columns={pageColumns}
              rowKey={(record: any) => record.id}
              dataSource={pageList}
              pagination={{
                total: this.state.pagination.total,
                pageSize: this.state.pagination.size,
              }}
              loading={this.state.loading}
              onChange={this.handleTableChange}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default OrderList
